import {
  type RuleValidationResult,
  type UnifiedRule,
  validateColumnOptionsRules,
} from '../column-options-editor/column-options-editor.types';

export type BasicControlRuleInputType = 'single-select' | 'multi-select';

export interface BasicControlRuleOption {
  value: string;
  label: string;
}

export interface BasicControlRulesEditorConfig {
  title?: string;
  controlLabel: string;
  inputType: BasicControlRuleInputType;
  options: BasicControlRuleOption[];
  rules: UnifiedRule[];
}

export const BASIC_CONTROL_RULE_SCOPE = '__self__';

export function normalizeBasicControlRules(rules: UnifiedRule[], validOptionValues?: Iterable<string>): UnifiedRule[] {
  const allowedValues = validOptionValues ? new Set(validOptionValues) : null;

  return rules.map((rule) => ({
    ...rule,
    when: {
      ...rule.when,
      column: BASIC_CONTROL_RULE_SCOPE,
      values: filterValues(rule.when.values ?? [], allowedValues),
    },
    then: {
      ...rule.then,
      targetColumn: BASIC_CONTROL_RULE_SCOPE,
      targetValues: filterValues(rule.then.targetValues ?? [], allowedValues),
    },
  }));
}

export function validateBasicControlRules(
  rules: UnifiedRule[],
  validOptionValues?: Iterable<string>
): RuleValidationResult {
  return validateColumnOptionsRules(normalizeBasicControlRules(rules, validOptionValues));
}

function filterValues(values: string[] | string | null | undefined, allowedValues: Set<string> | null): string[] {
  // Defensive: tolerate a non-array value (e.g. a bare string) from upstream callers
  const list: string[] = Array.isArray(values) ? values : values == null ? [] : [values];

  if (!allowedValues) {
    return [...list];
  }

  return list.filter((value) => allowedValues.has(value));
}
